// Maps the server's intake error codes (verbatim `groups/intake_*` from
// packages/shared/src/errors.ts, passed through the HTTP envelope) to a small
// UI-facing kind. The submit surface picks the localized message + whether to
// refetch the form (only `stale_version`) from this. Pure + unit-tested.

export type IntakeSubmitErrorKind =
  | 'required'
  | 'stale_version'
  | 'too_large'
  | 'malformed'
  | 'other';

const CODE_TO_KIND: Readonly<Record<string, IntakeSubmitErrorKind>> = {
  'groups/intake_required': 'required',
  'groups/intake_stale_version': 'stale_version',
  'groups/intake_too_large': 'too_large',
  'groups/intake_malformed': 'malformed',
};

export function classifyIntakeSubmitError(
  code: string | null | undefined,
): IntakeSubmitErrorKind {
  if (code == null) return 'other';
  return CODE_TO_KIND[code] ?? 'other';
}
